export default __webpack_public_path__ + "static/media/transactionPrice.3af49d9f.png";